export default {
  data() {
    return {
      search: '',
      keyboardWillFocus: false,
      keyboardHasFocus: false,
      favorites: JSON.parse(localStorage.getItem('favorites')) || [],
      showFavorites: this.$route.query.favorites ? true : false,
      selectedSide: '',
      selectedTypes: [],
      selectedPractice: [],
      selectedMediums: [],
      selectedSubjects: [],
      selectedPalettes: [],
      selectedA11y: [],
      selectedAffiliations: [],
      selectedThemedTours: this.$route.query.themed_tour ? [decodeURIComponent(this.$route.query.themed_tour)] : [],
      selectedSort: 'tour_number',
    }
  },
  computed: {
    filterByFavorites() {
      if (this.showFavorites) {
        return this.$root.artists.filter(artist => this.favorites.includes(artist.id));
      }

      return this.$root.artists;
    },
    filterBySide() {
      if (this.selectedSide) {
        return this.filterByFavorites.filter((artist) => {
          return this.selectedSide.indexOf(artist.tour_side.toUpperCase()) > -1;
        });
      }

      return this.filterByFavorites;
    },
    filterByType() {
      if (this.selectedTypes.length) {
        let filter = this.filterBySide.filter(artist => {
          let hasFilter = false;

          this.selectedTypes.forEach((filter) => {
            if (artist.type === filter) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterBySide;
      }
    },
    filterByPractice() {
      if (this.selectedPractice.length) {
        let filter = this.filterByType.filter(artist => {
          let hasFilter = false;

          this.selectedPractice.forEach((filter) => {
            if (artist.practice === filter) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterByType;
      }
    },
    filterByMedium() {
      if (this.selectedMediums.length) {
        let filter = this.filterByPractice.filter(artist => {
          if (!artist.artwork) return false;

          let hasFilter = false;
          let allItems = _.union(artist.artwork.map(art => art.mediums)[0]);

          this.selectedMediums.forEach((filter) => {
            if (allItems.includes(filter)) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterByPractice;
      }
    },
    filterBySubject() {
      if (this.selectedSubjects.length) {
        let filter = this.filterByMedium.filter(artist => {
          if (!artist.artwork) return false;

          let hasFilter = false;
          let allItems = _.union(artist.artwork.map(art => art.subject)[0]);

          this.selectedSubjects.forEach((filter) => {
            if (allItems.includes(filter)) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterByMedium;
      }
    },
    filterByPalette() {
      if (this.selectedPalettes.length) {
        let filter = this.filterBySubject.filter(artist => {
          if (!artist.artwork) return false;

          let hasFilter = false;
          let allItems = _.union(artist.artwork.map(art => art.palette)[0]);

          this.selectedPalettes.forEach((filter) => {
            if (allItems.includes(filter)) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterBySubject;
      }
    },
    filterByA11y() {
      if (this.selectedA11y.length) {
        let filter = this.filterByPalette.filter(artist => {
          let hasFilter = false;

          this.selectedA11y.forEach((filter) => {
            if (filter === 'family') {
              if (artist.a11y_family !== 'No') {
                hasFilter = true;
              }
              return;
            }

            if (artist['a11y_' + filter].length > 0 && !artist['a11y_' + filter].includes('None of the above')) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterByPalette;
      }
    },
    filterByAffiliation() {
      if (this.selectedAffiliations.length) {
        let filter = this.filterByA11y.filter(artist => {
          let hasFilter = false;
          this.selectedAffiliations.forEach((filter) => {
            if (artist.attendance.includes(filter)) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterByA11y;
      }
    },
    filterByThemedTour() {
      if (this.selectedThemedTours.length) {
        let filter = this.filterByAffiliation.filter(artist => {
          let hasFilter = false;
          this.selectedThemedTours.forEach((filter) => {
            if (artist.themed_tour === filter) {
              hasFilter = true;
              return;
            }
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.filterByAffiliation;
      }
    },
    sort() {
      if (this.selectedSort === 'alphabetical') {
        return [...this.filterByThemedTour].sort((a, b) => a.name.replaceAll('"', '').split(' ').join('').localeCompare(b.name.replaceAll('"', '').split(' ').join('')));
      } else if (this.selectedSort === 'tour_number') {
        return [...this.filterByThemedTour].sort((a, b) => (+a.tour_number) - (+b.tour_number)).sort((a, b) => !a.tour_number || !b.tour_number ? -1 : 0);
      } else if ('nearest') {
        return [...this.filterByThemedTour].sort((a, b) => a.distance - b.distance);
      }

      return this.filterByThemedTour;
    },
    artists() {
      // Filter by search
      let search = this.sort.filter(artist => {
        let query = this.search.toLowerCase();
        let params;

        if (!query.length) return true;

        params = artist.name;
        params += ',' + artist.tour_number;
        params += ',' + artist.medium;
        params += ',' + artist.tour_address;

        params = params.toLowerCase();

        return params.includes(query);
      });

      this.filtersChanged();

      return search;
    },

    filtersActive() {
      return this.selectedTypes.length > 0 || this.selectedSide.length > 0 || this.selectedPractice.length > 0 || this.selectedMediums.length > 0 || this.selectedSubjects.length > 0 || this.selectedPalettes.length > 0 || this.selectedA11y.length > 0 || this.selectedAffiliations.length > 0 || this.selectedThemedTours.length > 0 || this.showFavorites || this.search.length > 0;
    },
    filterNoticeDescription() {
      let filters = this.selectedTypes.concat(this.selectedPractice).concat(this.selectedMediums).concat(this.selectedSubjects).concat(this.selectedPalettes).concat(this.selectedThemedTours).concat(this.selectedA11y).concat(this.selectedAffiliations);
      if (this.selectedSide.length) filters.push(this.selectedSide);
      let str = filters.slice(0, 2).join(', ');

      if (filters.length > 2) {
        str = filters.slice(0, 1).join(', ');
        str += ', ' + (filters.length - 1) + ' more';
      }

      return str || (this.showFavorites ? 'Favorites' : '');
    },
  },
  methods: {
    filtersChanged() {},
    openFilters() {
      if (this.$refs.filters.drawerOpen) {
        this.$refs.filters.closeDrawer();
      } else {
        this.$refs.filters.openDrawer();
      }
    },
    clearFilters() {
      this.selectedSide = '';
      this.selectedTypes = [];
      this.selectedPractice = [];
      this.selectedMediums = [];
      this.selectedSubjects = [];
      this.selectedPalettes = [];
      this.selectedA11y = [];
      this.showFavorites = false;
      this.selectedEventType = [];
      this.selectedAffiliations = [];
      this.selectedThemedTours = [];
      this.filtersChanged();
      this.$router.push(this.$route.path);
    },
    showKeyboard(e) {
      this.keyboardWillFocus = true;
      setTimeout(() => {
        this.keyboardHasFocus = true;
      }, 150);
    },
    hideKeyboard(e) {
      e.target.blur();

      this.keyboardHasFocus = false;
      setTimeout(() => {
        this.keyboardWillFocus = false;
      }, 300);
    },
  },
  activated() {
    this.favorites = JSON.parse(localStorage.getItem('favorites')) || [];
    if (this.$route.query.favorites) {
      this.showFavorites = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FiltersUtils.js